import { useCallback } from 'react';
import { submitGame, getLeaderboard } from '../utils/api';

export function useLeaderboard(puzzle) {
  const submit = useCallback(
    async (cells, totalScore, username, retryCount, protestResult) => {
      return await submitGame(puzzle.date, cells, totalScore, username, retryCount, protestResult);
    },
    [puzzle.date]
  );

  const fetchLeaderboard = useCallback(async (date) => {
    try {
      return await getLeaderboard(date || puzzle.date);
    } catch {
      return null;
    }
  }, [puzzle.date]);

  return { submit, fetchLeaderboard };
}
